import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, finalize, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { api, environment } from '../../environments/environment';

declare interface RequestCustomOptions {
  authorization?: boolean;
  data?: object;
  headers?: { [header: string]: string | string[] };
}

var defaultOptions: RequestCustomOptions = {
  authorization: true,
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  },
  data: undefined,
};

export declare interface Response<T = null> {
  data?: T;
  success: boolean;
  code: number;
}

@Injectable({
  providedIn: 'root',
})
export class RestService {
  apiToRemake: any[] = [];
  isRefreshing: boolean = false;
  environment: any = environment;
  api: any = api;
  request: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(private http: HttpClient) {
    defaultOptions = {
      authorization: true,
      headers: {
        Authorization: `${this.api.prefixAuthorization} ${localStorage.getItem(
          'token'
        )}`,
      },
      data: undefined,
    };
  }

  setEnviroment(env: any, api: any) {
    this.environment = env;
    this.api = api;
  }

  setToken(token: string) {
    localStorage.setItem('token', token);
    defaultOptions = {
      authorization: true,
      headers: {
        Authorization: `${this.api.prefixAuthorization} ${localStorage.getItem(
          'token'
        )}`,
      },
      data: undefined,
    };
  }

  refreshToken(myApi: any, observableToComplete: any) {
    if (this.isRefreshing) {
      this.apiToRemake.push({ myApi: myApi, ob: observableToComplete });
    } else {
      this.isRefreshing = true;
      this.apiToRemake.push({ myApi: myApi, ob: observableToComplete });
      let refreshEndpoint: any = this.api;
      this.http
        .post(
          this.api.baseUrl + (refreshEndpoint?.refreshToken ?? '/auth/refresh'),
          {
            refresh_token: localStorage.getItem('refresh_token'),
          },
          defaultOptions
        )
        .subscribe({
          next: (value: any) => {
            this.setToken(value.token);
            localStorage.setItem('refresh_token', value.refreshToken);
            this.apiToRemake.forEach((myApiToRemake: any) => {
              if (myApiToRemake?.myApi?.method)
                switch (myApiToRemake?.myApi?.method) {
                  case 'get':
                    this.http
                      .get(myApiToRemake?.myApi?.endpoint, {
                        headers: {
                          Authorization: `${
                            this.api.prefixAuthorization
                          } ${localStorage.getItem('token')}`,
                        },
                      })
                      .subscribe({
                        next: (value: any) => {
                          myApiToRemake.ob.next(value);
                        },
                        error: (value: any) => {
                          myApiToRemake.ob.error(value);
                        },
                        complete: () => {
                          myApiToRemake.ob.complete();
                        },
                      });
                    break;
                  case 'delete':
                    this.http
                      .delete(myApiToRemake?.myApi?.endpoint, {
                        headers: {
                          Authorization: `${
                            this.api.prefixAuthorization
                          } ${localStorage.getItem('token')}`,
                        },
                      })
                      .subscribe({
                        next: (value: any) => {
                          myApiToRemake.ob.next(value);
                        },
                        error: (value: any) => {
                          myApiToRemake.ob.error(value);
                        },
                        complete: () => {
                          myApiToRemake.ob.complete();
                        },
                      });
                    break;
                  case 'post':
                    this.http
                      .post(
                        myApiToRemake?.myApi?.endpoint,
                        myApiToRemake?.myApi?.body,
                        {
                          headers: {
                            Authorization: `${
                              this.api.prefixAuthorization
                            } ${localStorage.getItem('token')}`,
                          },
                        }
                      )
                      .subscribe({
                        next: (value: any) => {
                          myApiToRemake.ob.next(value);
                        },
                        error: (value: any) => {
                          myApiToRemake.ob.error(value);
                        },
                        complete: () => {
                          myApiToRemake.ob.complete();
                        },
                      });
                    break;
                  case 'put':
                    this.http
                      .put(
                        myApiToRemake?.myApi?.endpoint,
                        myApiToRemake?.myApi?.body,
                        {
                          headers: {
                            Authorization: `${
                              this.api.prefixAuthorization
                            } ${localStorage.getItem('token')}`,
                          },
                        }
                      )
                      .subscribe({
                        next: (value: any) => {
                          myApiToRemake.ob.next(value);
                        },
                        error: (value: any) => {
                          myApiToRemake.ob.error(value);
                        },
                        complete: () => {
                          myApiToRemake.ob.complete();
                        },
                      });
                    break;
                  case 'patch':
                    this.http
                      .patch(
                        myApiToRemake?.myApi?.endpoint,
                        myApiToRemake?.myApi?.body,
                        {
                          headers: {
                            Authorization: `${
                              this.api.prefixAuthorization
                            } ${localStorage.getItem('token')}`,
                          },
                        }
                      )
                      .subscribe({
                        next: (value: any) => {
                          myApiToRemake.ob.next(value);
                        },
                        error: (value: any) => {
                          myApiToRemake.ob.error(value);
                        },
                        complete: () => {
                          myApiToRemake.ob.complete();
                        },
                      });
                    break;
                  default:
                    break;
                }
            });
          },
          error: () => {
            window.location.replace('');
          },
        });
    }
  }

  prepareOptions = (options: RequestCustomOptions) => {
    this.request.emit(true);
    for (const optionKey of Object.keys(defaultOptions)) {
      if (options === undefined) {
        options = defaultOptions;
      }
    }
  };

  post = (
    url: string,
    data: FormData | object | string,
    options: RequestCustomOptions = defaultOptions
  ) => {
    this.prepareOptions(options);
    if (options.data) {
      url += url.indexOf('?') > -1 ? '&' : '?';
      let i = 0;
      for (const key of Object.keys(options.data)) {
        url +=
          key +
          '=' +
          options.data +
          (i === Object.keys(options.data).length - 1 ? '' : '&');
        i++;
      }
    }
    let myObservable = new Observable((observable) => {
      this.http
        .post(
          this.api.baseUrl + (this.environment.stage || '') + url,
          data,
          options.authorization ? { headers: options.headers } : {}
        )
        .pipe(finalize(() => this.request.emit(false)))
        .subscribe({
          next: (value:any) => {
            observable.next(value);
          },
          error: (value:any) => {
            if(value.status == 403){
              window.history.back()
            }
            if (value.status == 401) {
              this.refreshToken(
                {
                  method: 'post',
                  body: data,
                  endpoint:
                    this.api.baseUrl + (this.environment.stage || '') + url,
                  options: options.authorization
                    ? { headers: options.headers }
                    : {},
                },
                observable
              );
            } else {
              observable.error(value);
            }
          },
        });
    });
    return myObservable;
  };

  put = (
    url: string,
    data: FormData | object | string,
    options: RequestCustomOptions = defaultOptions
  ) => {
    this.prepareOptions(options);
    if (options.data) {
      url += url.indexOf('?') > -1 ? '&' : '?';
      let i = 0;
      for (const key of Object.keys(options.data)) {
        url +=
          key +
          '=' +
          options.data +
          (i === Object.keys(options.data).length - 1 ? '' : '&');
        i++;
      }
    }
    let myObservable = new Observable((observable) => {
      this.http
        .put(
          this.api.baseUrl + (this.environment.stage || '') + url,
          data,
          options.authorization ? { headers: options.headers } : {}
        )
        .pipe(finalize(() => this.request.emit(false)))
        .subscribe({
          next: (value:any) => {
            observable.next(value);
          },
          error: (value:any) => {
            if(value.status == 403){
              window.history.back()
            }
            if (value.status == 401) {
              this.refreshToken(
                {
                  method: 'put',
                  body: data,
                  endpoint:
                    this.api.baseUrl + (this.environment.stage || '') + url,
                  options: options.authorization
                    ? { headers: options.headers }
                    : {},
                },
                observable
              );
            } else {
              observable.error(value);
            }
          },
        });
    });
    return myObservable;
  };

  patch = (
    url: string,
    data: FormData | object | string,
    options: RequestCustomOptions = defaultOptions
  ) => {
    this.prepareOptions(options);
    if (options.data) {
      url += url.indexOf('?') > -1 ? '&' : '?';
      let i = 0;
      for (const key of Object.keys(options.data)) {
        url +=
          key +
          '=' +
          options.data +
          (i === Object.keys(options.data).length - 1 ? '' : '&');
        i++;
      }
    }
    let myObservable = new Observable((observable) => {
      this.http
        .patch(
          this.api.baseUrl + (this.environment.stage || '') + url,
          data,
          options.authorization ? { headers: options.headers } : {}
        )
        .pipe(finalize(() => this.request.emit(false)))
        .subscribe({
          next: (value:any) => {
            observable.next(value);
          },
          error: (value:any) => {
            if(value.status == 403){
              window.history.back()
            }
            if (value.status == 401) {
              this.refreshToken(
                {
                  method: 'patch',
                  body: data,
                  endpoint:
                    this.api.baseUrl + (this.environment.stage || '') + url,
                  options: options.authorization
                    ? { headers: options.headers }
                    : {},
                },
                observable
              );
            } else {
              observable.error(value);
            }
          },
        });
    });
    return myObservable;
  };

  get = (url: string, options: RequestCustomOptions = defaultOptions) => {
    this.prepareOptions(options);
    if (options.data) {
      url += url.indexOf('?') > -1 ? '&' : '?';
      let i = 0;
      for (const key of Object.keys(options.data)) {
        url +=
          key +
          '=' +
          options.data +
          (i === Object.keys(options.data).length - 1 ? '' : '&');
        i++;
      }
    }
    let myObservable = new Observable((observable) => {
      this.http
        .get(
          this.api.baseUrl + (this.environment.stage || '') + url,
          options.authorization ? { headers: options.headers } : {}
        )
        .pipe(finalize(() => this.request.emit(false)))
        .subscribe({
          next: (value:any) => {
            observable.next(value);
          },
          error: (value:any) => {
            if(value.status == 403){
              window.history.back()
            }
            if (value.status == 401) {
              this.refreshToken(
                {
                  method: 'get',
                  endpoint:
                    this.api.baseUrl + (this.environment.stage || '') + url,
                  options: options.authorization
                    ? { headers: options.headers }
                    : {},
                },
                observable
              );
            } else {
              observable.error(value);
            }
          },
        });
    });
    return myObservable;
  };

  options = (url: string) => {
    this.request.emit(true);
    return this.http
      .options(this.api.baseUrl + (this.environment.stage || '') + url)
      .pipe(finalize(() => this.request.emit(false)));
  };

  delete = (url: string, options: RequestCustomOptions = defaultOptions) => {
    this.prepareOptions(options);
    if (options.data) {
      url += url.indexOf('?') > -1 ? '&' : '?';
      let i = 0;
      for (const key of Object.keys(options.data)) {
        url +=
          key +
          '=' +
          options.data +
          (i === Object.keys(options.data).length - 1 ? '' : '&');
        i++;
      }
    }
    let myObservable = new Observable((observable) => {
      this.http
        .delete(
          this.api.baseUrl + (this.environment.stage || '') + url,
          options.authorization ? { headers: options.headers } : {}
        )
        .pipe(finalize(() => this.request.emit(false)))
        .subscribe({
          next: (value:any) => {
            observable.next(value);
          },
          error: (value:any) => {
            if(value.status == 403){
              window.history.back()
            }
            if (value.status == 401) {
              this.refreshToken(
                {
                  method: 'delete',
                  endpoint:
                    this.api.baseUrl + (this.environment.stage || '') + url,
                  options: options.authorization
                    ? { headers: options.headers }
                    : {},
                },
                observable
              );
            } else {
              observable.error(value);
            }
          },
        });
    });
    return myObservable;
  };
}

export interface GenericResponse<T> {
  data: T;
  success: boolean;
  additionalData: any;
}
